export const SET_LOADING = 'SET_LOADING'
export const GET_ALL_DATA = 'GET_ALL_DATA'
export const CLEAR_CONTRACT_LOST_DATA = 'CLEAR_CONTRACT_LOST_DATA'
